import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardHeader from "@material-ui/core/CardHeader";
import List from "@material-ui/core/List";
import ButtonJoin from "./ButtonJoin";
import ButtonAccept from "./ButtonAccept";
import ButtonEditTeam from "./ButtonEditTeam";
import ButtonOut from "./ButtonOut";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TeamMember from "./TeamMember";

const styles = {
  container: {
    width: 300,
    borderRadius: 8
  },
  header: {
    backgroundColor: "#f5f5f5"
  }
};

const CONVERT_TRACK_TO_TAGS = {
  BlockChain: "#blockchain #IBL",
  FinTech: "#fintech #bankify",
  BigData: "#bigdata #viettel"
};

class CardTeam extends React.Component {
  render() {
    const { classes, team } = this.props;
    if (!team.id || !team.members || team.members.length === 0) return <div />;
    const teamId = team.id;

    let subHeader = team.intro;
    if (team.track && CONVERT_TRACK_TO_TAGS[team.track])
      subHeader = subHeader + " " + CONVERT_TRACK_TO_TAGS[team.track];

    return (
      <Grid key={teamId} item>
        <Card className={classes.container}>
          <CardHeader
            title={
              <Typography variant="title">
                {team.name === "untitled" ? "" : team.name}
              </Typography>
            }
            subheader={subHeader || "to be update"}
            className={classes.header}
            action={<ButtonEditTeam teamId={teamId} />}
          />
          <List>
            {team.members.map(member => (
              <TeamMember key={member.id} teamId={teamId} member={member} />
            ))}
          </List>
          <CardActions>
            <ButtonOut teamId={teamId} />
            <ButtonAccept teamId={teamId} />
            <ButtonJoin teamId={teamId} />
          </CardActions>
        </Card>
      </Grid>
    );
  }
}

export default withStyles(styles)(CardTeam);
